/* Mattress Central cart: delivery picker, ZIP → nearest showroom, one-tap add-ons */
(function () {
  'use strict';
  var DEL = 'mc-delivery';
  var STORES = [
    ['Plano', 33.0036, -96.7074],
    ['Anna', 33.3424, -96.587],
    ['Princeton', 33.174, -96.5012],
    ['Denton', 33.188, -97.105],
    ['Euless / Colleyville', 32.876, -97.1007],
    ['Fort Worth', 32.6769, -97.4029]
  ];
  var busy = false;
  var autoTries = 0;
  var zips = null;

  function root() { return document.querySelector('[data-mc-delivery]'); }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function setBusy(on) {
    busy = on;
    document.querySelectorAll('.mcx-del, .mcx-ups').forEach(function (el) { el.classList.toggle('is-busy', on); });
  }

  function fixBubble() {
    var r = root();
    if (!r || !r.dataset.visibleCount) return;
    var n = parseInt(r.dataset.visibleCount, 10);
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]').forEach(function (s) { s.textContent = n; });
  }

  function rerender() {
    if (window.location.pathname.replace(/\/$/, '') === '/cart') { window.location.reload(); return Promise.resolve(); }
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && s['cart-drawer']) {
          var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
          var ni = doc.querySelector('.drawer__inner');
          var oi = drawer.querySelector('.drawer__inner');
          if (ni && oi) oi.innerHTML = ni.innerHTML;
          var nd = doc.querySelector('cart-drawer');
          if (nd) drawer.classList.toggle('is-empty', nd.classList.contains('is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        fixBubble();
        hydrate();
      });
  }

  /* Replace whatever delivery line is in the cart with the chosen variant */
  function setDelivery(variantId, props) {
    if (busy) return Promise.resolve();
    setBusy(true);
    return getCart()
      .then(function (cart) {
        var updates = {};
        cart.items.forEach(function (i) { if (i.handle === DEL) updates[i.key] = 0; });
        var ups = Object.keys(updates);
        return (ups.length ? post('/cart/update.js', { updates: updates }) : Promise.resolve())
          .then(function () {
            if (!variantId) return null;
            var p = props || {};
            var z = store('mcZip');
            if (z) p._ZIP = z;
            return post('/cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: 1, properties: p }] });
          });
      })
      .then(function () { setBusy(false); return rerender(); })
      .catch(function () { setBusy(false); });
  }

  /* Keep the cart consistent: one delivery line when a mattress/base is in the cart, none otherwise */
  function sync() {
    var r = root();
    if (!r || busy || r.dataset.mcSynced) return;
    r.dataset.mcSynced = '1';
    fixBubble();
    if (autoTries >= 3) return;
    var needs = r.dataset.needs === 'true';
    var has = !!r.dataset.current;
    var qty = parseInt(r.dataset.currentQty || '0', 10);
    if (needs && !has && r.dataset.bronze) {
      autoTries++;
      setDelivery(r.dataset.bronze, {});
    } else if (!needs && has) {
      autoTries++;
      setDelivery(null);
    } else if (has && qty > 1 && r.dataset.currentKey) {
      setBusy(true);
      post('/cart/change.js', { id: r.dataset.currentKey, quantity: 1 }).then(function () { setBusy(false); rerender(); });
    }
  }

  function hydrate() {
    var r = root();
    if (!r) return;
    var input = r.querySelector('[data-mc-zip]');
    var saved = store('mcZip');
    if (input && !input.value && saved) input.value = saved;
    if (input && input.value.length === 5) showNearest(input.value, true);
    sync();
  }

  function hav(a, b, c, d) {
    var R = 3958.8, t = function (x) { return x * Math.PI / 180; };
    var h = Math.pow(Math.sin(t(c - a) / 2), 2) + Math.cos(t(a)) * Math.cos(t(c)) * Math.pow(Math.sin(t(d - b) / 2), 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function loadZips() {
    if (zips) return Promise.resolve(zips);
    var r = root();
    if (!r || !r.dataset.zips) return Promise.resolve({});
    return fetch(r.dataset.zips).then(function (x) { return x.json(); }).then(function (j) { zips = j; return j; }).catch(function () { return {}; });
  }

  function showNearest(zip, quiet) {
    var r = root();
    if (!r) return;
    var out = r.querySelector('[data-mc-zip-out]');
    if (!/^\d{5}$/.test(zip)) { if (out && !quiet) out.textContent = 'Enter a 5-digit ZIP code.'; return; }
    loadZips().then(function (z) {
      var ll = z[zip];
      if (!out) return;
      if (!ll) {
        out.innerHTML = 'We deliver all across DFW. <a href="/pages/find-a-store">See all 6 showrooms</a>';
        return;
      }
      var best = STORES.map(function (s) { return [s[0], hav(ll[0], ll[1], s[1], s[2])]; }).sort(function (a, b) { return a[1] - b[1]; })[0];
      var miles = best[1] < 1 ? 'under 1' : Math.round(best[1]);
      out.innerHTML = '<strong>Nearest showroom: Mattress Central ' + best[0] + '</strong> &middot; about ' + miles + ' mi away. Free delivery to ' + zip + '.';
      r.dataset.nearest = best[0];
      store('mcNearest', best[0]);
    });
  }

  /* Capture-phase listeners so Dawn's quantity handler on cart-drawer-items never sees our inputs */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.closest('[data-mc-delivery]')) return;
    e.stopPropagation();
    if (t.name === 'mc-delivery') {
      var props = {};
      if (t.dataset.tier === 'pickup') props['Pickup store'] = store('mcNearest') || 'Plano';
      document.querySelectorAll('.mcx-opt').forEach(function (l) { l.classList.toggle('is-on', l.contains(t)); });
      setDelivery(t.value, props);
    } else if (t.matches('[data-mc-store]')) {
      var r = root();
      store('mcNearest', t.value);
      setDelivery(r.dataset.current, { 'Pickup store': t.value });
    } else if (t.matches('[data-mc-zip]')) {
      store('mcZip', t.value.trim());
      showNearest(t.value.trim());
    }
  }, true);

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-mc-zip]')) {
      e.stopPropagation();
      t.value = t.value.replace(/\D/g, '').slice(0, 5);
      if (t.value.length === 5) { store('mcZip', t.value); showNearest(t.value); }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-mc-zip]')) {
      e.preventDefault();
      e.stopPropagation();
      showNearest(e.target.value.trim());
    }
  }, true);

  document.addEventListener('click', function (e) {
    var go = e.target.closest && e.target.closest('[data-mc-zip-go]');
    if (go) {
      var i = root() && root().querySelector('[data-mc-zip]');
      if (i) { store('mcZip', i.value.trim()); showNearest(i.value.trim()); }
      return;
    }
    var add = e.target.closest && e.target.closest('[data-mc-add]');
    if (add) {
      e.preventDefault();
      if (busy) return;
      add.disabled = true;
      add.textContent = 'Adding…';
      setBusy(true);
      post('/cart/add.js', { items: [{ id: parseInt(add.dataset.mcAdd, 10), quantity: 1 }] })
        .then(function () { setBusy(false); return rerender(); })
        .catch(function () { setBusy(false); add.disabled = false; add.textContent = '+ Add'; });
    }
  });

  /* Re-sync whenever the drawer or cart page re-renders (Dawn swaps innerHTML) */
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () { var r = root(); if (r && !r.dataset.mcSynced) hydrate(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
  else hydrate();
})();
